(() => {
  if (window.aureaReady) return;
  window.aureaReady = true;

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-aurea-qa]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('button[type=submit]');
    btn && btn.setAttribute('disabled', '');
    const drawer = document.querySelector('cart-drawer');
    const fd = new FormData(form);
    if (drawer && drawer.getSectionsToRender) {
      fd.append('sections', drawer.getSectionsToRender().map((s) => s.id));
      fd.append('sections_url', window.location.pathname);
    }
    try {
      const res = await fetch(window.routes.cart_add_url, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd });
      const state = await res.json();
      if (state.status) throw new Error(state.description || state.message);
      if (drawer && drawer.renderContents) {
        drawer.classList.remove('is-empty');
        drawer.renderContents(state);
      } else {
        window.location = window.routes.cart_url;
      }
    } catch (err) {
      console.error(err);
    } finally {
      btn && btn.removeAttribute('disabled');
    }
  });

  const initCarousel = (root) => {
    if (root.dataset.aureaCarousel) return;
    root.dataset.aureaCarousel = '1';
    const area = root.querySelector('.aurea-scroll');
    const prev = root.querySelector('.aurea-arrow--prev');
    const next = root.querySelector('.aurea-arrow--next');
    if (!area) return;
    const step = () => {
      const item = area.children[0];
      if (!item) return area.clientWidth;
      const gap = parseFloat(getComputedStyle(area).columnGap) || 0;
      return item.getBoundingClientRect().width + gap;
    };
    const update = () => {
      const max = area.scrollWidth - area.clientWidth - 1;
      prev && prev.toggleAttribute('disabled', area.scrollLeft <= 1);
      next && next.toggleAttribute('disabled', area.scrollLeft >= max);
    };
    prev && prev.addEventListener('click', () => area.scrollBy({ left: -step(), behavior: 'smooth' }));
    next && next.addEventListener('click', () => area.scrollBy({ left: step(), behavior: 'smooth' }));
    area.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  };
  const scan = () => document.querySelectorAll('[data-aurea-carousel]').forEach(initCarousel);
  document.addEventListener('DOMContentLoaded', scan);
  document.addEventListener('shopify:section:load', scan);
  scan();
})();

(function () {
  function looksLikeCards(el) {
    var kids = el.children;
    if (kids.length < 3 || kids.length > 8) return false;
    var ok = 0;
    for (var i = 0; i < kids.length; i++) {
      var k = kids[i];
      if (k.nodeType !== 1) continue;
      var hasHeading = k.querySelector('h2,h3,h4,h5');
      var hasVisual = k.querySelector('img,svg');
      if (hasHeading && hasVisual) ok++;
    }
    return ok >= 3;
  }

  function makeScroller(el) {
    if (el.dataset.mckDone) return;
    el.classList.add('mck-scroller');
    el.dataset.mckDone = '1';

    var dots = document.createElement('div');
    dots.className = 'mck-dots';
    for (var d = 0; d < el.children.length; d++) {
      var s = document.createElement('span');
      if (d === 0) s.className = 'is-active';
      dots.appendChild(s);
    }
    el.parentNode.insertBefore(dots, el.nextSibling);

    el.addEventListener('scroll', function () {
      var idx = Math.round(el.scrollLeft / (el.scrollWidth / el.children.length));
      for (var n = 0; n < dots.children.length; n++) {
        dots.children[n].className = (n === idx) ? 'is-active' : '';
      }
    }, { passive: true });
  }

  function run() {
    if (window.innerWidth > 749) return;
    var main = document.querySelector('main') || document.body;
    var candidates = [];
    var all = main.querySelectorAll('div, ul');

    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (el.closest('header, footer, nav, .mck-scroller, .vc-benefits, .mc-no-scroller, [class*="why-shop"]')) continue;
      if (looksLikeCards(el)) candidates.push(el);
    }

    var final = candidates.filter(function (c) {
      return !candidates.some(function (o) { return o !== c && c.contains(o); });
    });

    final.forEach(makeScroller);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
